import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TPipe } from '@pipes/t.pipe';
import { OverlayService } from '@services/ui/overlay.service';
import { AbbCommonModule } from 'app/abb-common.module';
import { FoundDevicesListQuery } from 'gql/graphql';
import { DeviceConfigurationModalComponent } from './device-configuration-modal.component';
import { OverflowTooltipDirective } from '@directives/overflow-tooltip.directive';

@Component({
  selector: 'abb-devices-configuration',
  standalone: true,
  template: `
    <div class="flex flex-col h-full">
      <!-- Header semplice con pulsante Scan again -->
      <div class="flex justify-between items-center mb-3 sticky flex-shrink-0">
        <span></span>
        <abb-button
          id="scan-again"
          variant="secondary"
          [disabled]="scanAgainDisabled()"
          [loading]="scanAgainLoading()"
          (onclick)="handleScanAgain()"
        >
          {{ 'Scan again' | t }}
        </abb-button>
      </div>
      
      <!-- Tabella con scroll controllato -->
      <div class="flex-1 min-h-0">
        <div class="h-full">
          <table class="w-full text-left border-separate">
            <thead class="sticky top-0 bg-white z-10">
              <tr class="text-sm text-gray-500">
                <th class="px-4">{{ 'ID' | t }}</th>
                <th class="px-4">{{ 'Name' | t }}</th>
                <th class="px-4">{{ 'Communication protocol' | t }}</th>
                <th class="px-4"></th>
              </tr>
            </thead>
            <tbody>
              @for(device of devices(); track device?.id) {
              <tr class="text-base">
                <td class="text-sm text-gray-500 truncate px-4">
                  <span overflowTooltip>{{ device?.id }}</span>
                </td>
                <td overflowTooltip class="font-semibold truncate px-4">
                  {{ device?.name }}
                </td>
                <td overflowTooltip class="font-semibold truncate px-4">
                  {{ device?.communicationProtocol?.name | t }}
                </td>
                <td class="px-4">
                  <button (click)="configureDevice($event, device)">
                    <abb-icon class="-scale-x-100" name="mat/build"></abb-icon>
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `,
  styles: ``,
  host: {
    class: 'flex flex-col h-full',
  },
  imports: [
    CommonModule,
    AbbCommonModule,
    TPipe,
    MatSelectModule,
    FormsModule,
    OverflowTooltipDirective,
  ],
})
export class DevicesConfigurationComponent {
  devices = input.required<FoundDevicesListQuery['foundDevicesList'] | null>();
  scanAgainDisabled = input<boolean>(false);
  scanAgainLoading = input<boolean>(false);
  scanAgain = output<void>();

  constructor(private readonly overlay: OverlayService) {}

  handleScanAgain(): void {
    this.scanAgain.emit();
  }

  configureDevice(
    event: Event,
    device: FoundDevicesListQuery['foundDevicesList'][number]
  ): void {
    if (device) {
      this.overlay.openModal(DeviceConfigurationModalComponent, {
        device,
      });
    }
  }
}
